import { conformToMask } from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
/**
 * This is an add-on for text mask inputs
 * allows users to define custom masks for number inputs
 * full reference on how it works https://github.com/text-mask/text-mask/tree/master/addons/#readme
 */
const phoneNumberMask = [
  '(',
  /[2-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const zipcodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/]

export { conformToMask, createNumberMask, phoneNumberMask, zipcodeMask }
